import {call, put} from 'redux-saga/effects';
import {ISkeletonSaga, skeletonSaga} from '../../apis/skeleton/skeletonSaga';
import {GENERIC_ERROR} from '../../constants/ErrorConstants';
import {HideLivePayload} from '../../@types/actions';
import {HIDE_ALERT_SUCCESS} from "../../constants/LiveConstants";
import {HideLiveCall} from "../../apis/user";

function* tryFunction(payload: HideLivePayload) {
    yield call(HideLiveCall, payload);
    const alertKey = payload.sbv && payload.sbv !== '#'
        ? `${payload.eventId}-${payload.marketId}@${payload.sbv}-${payload.signId}`
        : `${payload.eventId}-${payload.marketId}-${payload.signId}`
    yield put({
        type: HIDE_ALERT_SUCCESS,
        payload: {[alertKey]: payload.margin}
    });
}

export function* hideAlertSaga({payload}: { payload: HideLivePayload }): Generator {
    const sagaPayload: ISkeletonSaga = {
        tryApiCall: {function: tryFunction, payload: payload},
        failedType: GENERIC_ERROR
    };
    yield call(skeletonSaga, sagaPayload);
}